"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdsAgentChatLoadedEvent = exports.createAdsAgentChatSendMessageEvent = exports.createAdsAgentChatPageActionEvent = exports.subscribeToAdsAgentChatEvents = exports.publishAdsAgentChatEvent = void 0;
const types_1 = require("./types");
/**
 * Publish an Ads Agent Chat event via window dispatch.
 */
function publishAdsAgentChatEvent(event) {
    const customEvent = new window.CustomEvent(event.type, {
        detail: event
    });
    window.dispatchEvent(customEvent);
}
exports.publishAdsAgentChatEvent = publishAdsAgentChatEvent;
/**
 * Subscribe to Ads Agent Chat events with optional filter.
 * Use the generic parameter for type safety on the event in the handler.
 */
function subscribeToAdsAgentChatEvents(type, handler, filter) {
    const listener = (ev) => {
        const customEvent = ev;
        const detail = customEvent.detail;
        if (!detail)
            return;
        if (filter && !filter(detail))
            return;
        handler(detail);
    };
    window.addEventListener(type, listener);
    // Return unsubscribe function
    return () => window.removeEventListener(type, listener);
}
exports.subscribeToAdsAgentChatEvents = subscribeToAdsAgentChatEvents;
/**
 * Create an Ads Agent Chat page action event.
 */
function createAdsAgentChatPageActionEvent(agentIdentifier, payload, id, timestamp) {
    return {
        id: id || crypto.randomUUID(),
        type: types_1.AdsAgentChatEventType.PAGE_ACTION,
        timestamp: timestamp || Date.now(),
        agentIdentifier,
        payload
    };
}
exports.createAdsAgentChatPageActionEvent = createAdsAgentChatPageActionEvent;
/**
 * Create an Ads Agent Chat send message event.
 */
function createAdsAgentChatSendMessageEvent(message, options, id, timestamp) {
    return {
        id: id || crypto.randomUUID(),
        type: types_1.AdsAgentChatEventType.CHAT_SEND_MESSAGE,
        timestamp: timestamp || Date.now(),
        message,
        selectedAgentIdentifier: options?.selectedAgentIdentifier,
        additionalContext: options?.additionalContext,
        newConversation: options?.newConversation,
        contentType: options?.contentType || types_1.MessageEventContentType.PLAIN_TEXT // default to plain text if not specified
    };
}
exports.createAdsAgentChatSendMessageEvent = createAdsAgentChatSendMessageEvent;
/**
 * Create an Ads Agent Chat loaded event.
 */
function createAdsAgentChatLoadedEvent(id, timestamp) {
    return {
        id: id || crypto.randomUUID(),
        type: types_1.AdsAgentChatEventType.CHAT_LOADED,
        timestamp: timestamp || Date.now()
    };
}
exports.createAdsAgentChatLoadedEvent = createAdsAgentChatLoadedEvent;
// Re-export types for convenience
__exportStar(require("./types"), exports);
//# sourceMappingURL=index.js.map